<!-- <nz-spin [nzSpinning]="loadingExport">
    <div nz-row class="print-pdf">
        <div
            nz-col
            nzSpan="12"
            nzOffset="6"
        >
            <button
                nz-button
                nzType="primary"
                [nzLoading]="loadingDownload"
                (click)="htmltoPDF()"
            >
                <i
                    nz-icon
                    nzType="download"
                ></i>
                Descarcă PDF
            </button>
        </div>
    </div>
</nz-spin> -->
<div class="print-only-header">
  <img src="/assets/img/db_pdf_logo.jpg" alt="Logo" class="print-logo">
</div>

<!-- Notes button - positioned at right side of page -->
<div class="notes-btn-container">
  <button nz-button nzType="primary" class="notes-edit-btn" (click)="toggleNotesForm()">
    <i nz-icon nzType="edit" nzTheme="outline"></i>
    Editează Notițe
  </button>
</div>

<div nz-row class="content">
  <div nz-col nzSpan="16" nzOffset="4" style="text-align: center" class="header-report">
    <h1 class="report-title">
      <!-- <span class="c-multi">Iti multumesc</span>
            <span class="small">pentru incredere!</span>
            <br> -->
      <div nz-col nzSpan="24" [ngClass]="['p-3', 'language-status']" *ngIf="isLanguageSelectorVisible">
        <h5 nz-typography style="margin-right: 5px">
          Limba: {{ "system_language" | translate }}
          <nz-select nzPlaceHolder="Selectează limba" [(ngModel)]="sysLanguage" (ngModelChange)="switchLanguage($event)"
            nzSize="small" style="width: 120px; color: black !important">
            <nz-option nzValue="ro" nzLabel="Română"></nz-option>
            <nz-option nzValue="en" nzLabel="Engleză"></nz-option>
          </nz-select>
        </h5>
      </div>
      <!-- <h1 class="report-title"> -->
      <!--   <h2 class="upload-title"> -->
      <!--     <strong>{{ "diag_fin_title" | translate }}</strong> -->
      <!--   </h2> -->
      <!-- </h1> -->
      <!-- <div class="report-info c-bg-multi"> -->
      <!--   <div> -->
      <!--     <!-- <span>1</span> -->
      <!--     <p> -->
      <!--       {{ "first_message" | translate }} -->
      <!--     </p> -->
      <!--   </div> -->
      <!--   <div> -->
      <!--     <span>2</span> -->
      <!--     <p> -->
      <!--       {{ "second_message" | translate }} -->
      <!--     </p> -->
      <!--     <p [innerHTML]="bodyContent"></p> -->
      <!--     <nz-spin [nzSpinning]="!loadingDiagnostic" class="custom-spin"></nz-spin> -->
      <!--   </div> -->
      <!-- </div> -->
      <span>
        <strong>{{ fileMonth.toString() | translate }} {{ fileYear }}</strong>
      </span>
      <br />

      <!-- Notes form - similar style to email form -->
      <div class="notes-form-container" *ngIf="showNotesForm">
        <div class="notes-form-header">
          <span>Notițele mele pentru acest raport</span>
          <button nz-button nzType="text" nzSize="small" (click)="toggleNotesForm()">
            <i nz-icon nzType="close"></i>
          </button>
        </div>

        <textarea
          nz-input
          placeholder="Adaugă notițele tale aici..."
          [(ngModel)]="fileNotes"
          [nzAutosize]="{ minRows: 3, maxRows: 8 }"
          [disabled]="savingNotes"
          class="notes-textarea"
        ></textarea>

        <div class="notes-form-actions">
          <button
            nz-button
            nzType="primary"
            [nzLoading]="savingNotes"
            [disabled]="savingNotes"
            (click)="saveFileNotes()"
            class="save-notes-btn"
          >
            <i nz-icon nzType="save" *ngIf="!savingNotes"></i>
            {{ savingNotes ? 'Se salvează...' : 'Salvează notițele' }}
          </button>
        </div>
      </div>

      <!-- <strong>Iata ce poti vedea in acest raport:</strong>
            <br> -->
      <span style="font-size: 16px">
        {{ "under_date" | translate }}
      </span>
    </h1>
  </div>
</div>

<div class="info-columns columns-landscape outline" style="margin-top: 4rem" nz-col nzSpan="16" nzOffset="4">
  <ul>
    <li (click)="goToAnchor('slide_1')">
      <span class="number">01</span>
      <p class="cuprins">
        {{ "first_row" | translate }}
      </p>
    </li>
    <li (click)="goToAnchor('slide_11')">
      <span class="number">02</span>
      <p class="cuprins">
        {{ "second_row" | translate }}
      </p>
    </li>
    <li (click)="goToAnchor('slide_13')">
      <span class="number">03</span>
      <p class="cuprins">
        {{ "third_row" | translate }}
      </p>
    </li>
    <li (click)="goToAnchor('slide_22')">
      <span class="number">04</span>
      <p class="cuprins">
        {{ "forth_row" | translate }}
      </p>
    </li>
    <li (click)="goToAnchor('slide_24')">
      <span class="number">05</span>
      <p class="cuprins">
        {{ "fifth_row" | translate }}
      </p>
    </li>
    <li (click)="goToAnchor('slide_30')">
      <span class="number">06</span>
      <p class="cuprins">
        {{ "sixth_row" | translate }}
      </p>
    </li>
    <!-- <li (click)="goToAnchor('slide_24')">
            <span class="number">06</span>
            <p>
                Intri in posesia unei radiografii care iti arata
                <span style="color: #00a2d4">
                    <strong>'Starea de sanatate'</strong>
                    a afacerii tale
                    <strong>-</strong>
                    INDICATORII FINANCIARI DE PERFORMANTA (KPI’s).
                </span>
                Dintr-o singura privire poti sa vezi daca esti verde (sanatate), galben (atentie) sau rosu (nevoie de tratament). O sa gasesti detalii despre fiecare indicator si cum este interpretat rezultatul tau fata de benchmarck. Ai si recomandari pentru redresare acolo unde este cazul.
            </p>
        </li>
        <li (click)="goToAnchor('slide_27')">
            <span class="number">07</span>
            <p>
                Primesti un ghid al
                <span style="color: #00a2d4">
                    <strong>“</strong>
                    <strong>OBICEIURILOR DE PUS IN PRACTICA</strong>
                </span>
                la fiecare final de luna”. Cu aceste 5 obiceiuri simple si alocarea catorva responsabilitati in echipa ta, poti scurta drumul de la profitul din balanta la cash-ul din banca.
            </p>
        </li> -->
  </ul>
</div>

<!-- <div nz-row class="things">
    <div nz-col nzSpan="16" nzOffset="4">
        <img (click)="goToAnchor('slide_1')" style="cursor: pointer;" src="/assets/img/10-things/1.png" />
        <img (click)="goToAnchor('slide_2')" style="cursor: pointer;" src="/assets/img/10-things/2.png" />
        <img (click)="goToAnchor('slide_5')" style="cursor: pointer;" src="/assets/img/10-things/3.png" />
        <img (click)="goToAnchor('slide_12')" style="cursor: pointer;" src="/assets/img/10-things/4.png" />
        <img (click)="goToAnchor('slide_15')" style="cursor: pointer;" src="/assets/img/10-things/5.png" />
        <img (click)="goToAnchor('slide_24')" style="cursor: pointer;" src="/assets/img/10-things/6.png" />
        <img (click)="goToAnchor('slide_27')" style="cursor: pointer;" src="/assets/img/10-things/7.png" />
    </div>
</div> -->

<div id="topHead">
  <nz-spin [nzSpinning]="loadingSlides">
    <div *ngFor="let slide of textSlides; index as i" id="slide_{{ i }}" class="slides previewContainer_{{ slide.id }}">
      <!-- <div *ngIf="slide.slideClass == 'topHeader'; then topHeader"></div> -->
      <div *ngIf="slide.slideClass == 'bottomHeader'; then bottomHeader"></div>
      <div
        *ngIf="slide.slideClass == 'tableChart' && (slide.id == 1 || slide.id == 2 || slide.id == 3 || slide.id == 4 || slide.id == 7 || slide.id == 6 || slide.id == 5); then tableChartCollapse">
      </div>
      <div
        *ngIf="slide.slideClass == 'tableChart' && slide.id != 1 && slide.id != 2 && slide.id != 3 && slide.id != 4 && slide.id != 7 && slide.id != 6 && slide.id != 5; then tableChart">
      </div>
      <div *ngIf="slide.slideClass == 'title'; then title"></div>
      <div *ngIf="slide.slideClass == 'conclusions'; then conclusions"></div>
      <div *ngIf="slide.slideClass == 'kpi'; then kpi"></div>
      <div *ngIf="slide.slideClass == 'profitCash'; then profitCash"></div>
      <div *ngIf="slide.slideClass == 'twoChart'; then otherTemplate"></div>
      <div *ngIf="slide.slideClass == 'imageBar'; then imageBar"></div>
      <div *ngIf="slide.slideClass == 'imageFloat'; then imageFloat"></div>
      <div *ngIf="slide.slideClass == null && slide.chartType == 'table'; then table"></div>
      <div *ngIf="slide.slideClass == null && slide.chartType == 'table1'; then table1"></div>
      <div *ngIf="slide.slideClass == null && slide.chartType == 'pie'; then pie"></div>
      <div *ngIf="slide.slideClass == null && (slide.chartType == 'bar' || slide.chartType == 'stackedBar'); then bar">
      </div>
      <div
        *ngIf="slide.slideClass == null && slide.chartType != 'table' && slide.chartType != 'table1' && slide.chartType != 'pie' && slide.chartType != 'bar' && slide.chartType != 'stackedBar'; then otherTemplate">
      </div>

      <!-- SLIDE FOR TOP HEADER -->
      <ng-template #topHeader>
        <div nz-row [ngClass]="'top-header'">
          <div nz-col nzSpan="16" nzOffset="4">
            <div class="top-content">
              <h3 nz-typography [ngClass]="'p-lg'" [innerHtml]="convert(slide.title)">
                {{ slide.title }}
              </h3>
              <div [ngClass]="'p-content'" [innerHtml]="convert(slide.content)">
                {{ slide.content }}
              </div>

              <svg [ngClass]="'bg-logo'" xmlns="http://www.w3.org/2000/svg"
                style="clip-rule: evenodd; fill-rule: evenodd; shape-rendering: geometricPrecision; text-rendering: geometricPrecision; image-rendering: optimizeQuality"
                viewBox="0 0 8956 8003" version="1.1" xmlns:xml="http://www.w3.org/XML/1998/namespace"
                xml:space="preserve">
                <g id="Layer_x0020_1">
                  <path class="fil0"
                    d="M 2565 2872 l 758 0 l 0 -2872 l 932 0 l 0 2872 l 0 5131 l -932 0 l -758 0 c -1411 0 -2565 -1154 -2565 -2565 l 0 0 c 0 -1411 1154 -2565 2565 -2565 Z m -54 987 l 812 0 l 0 3157 l -812 0 c -868 0 -1579 -710 -1579 -1579 l 0 0 c 0 -868 710 -1579 1579 -1579 Z">
                  </path>
                  <path class="fil1"
                    d="M 6391 2872 l -758 0 l 0 -2872 l -932 0 l 0 2872 l 0 5131 l 932 0 l 758 0 c 1411 0 2565 -1154 2565 -2565 l 0 0 c 0 -1411 -1154 -2565 -2565 -2565 Z m 54 987 l -812 0 l 0 3157 l 812 0 c 868 0 1579 -710 1579 -1579 l 0 0 c 0 -868 -710 -1579 -1579 -1579 Z">
                  </path>
                </g>
              </svg>
            </div>
          </div>
        </div>
      </ng-template>

      <!-- SLIDE FOR BOTTOM HEADER -->
      <ng-template #bottomHeader>
        <div nz-row [ngClass]="'bottom-header'">
          <div nz-col nzSpan="16" nzOffset="4">
            <div class="top-content">
              <h3 nz-typography [ngClass]="'p-lg'" [innerHtml]="convert(slide.title)">
                {{ slide.title }}
              </h3>
              <div [ngClass]="'p-content'" [innerHtml]="convert(slide.content)">
                {{ slide.content }}
              </div>

              <!-- <svg [ngClass]="'bg-logo'" xmlns="http://www.w3.org/2000/svg" style="clip-rule: evenodd; fill-rule: evenodd; shape-rendering: geometricPrecision; text-rendering: geometricPrecision; image-rendering: optimizeQuality;" viewBox="0 0 8956 8003" version="1.1" xmlns:xml="http://www.w3.org/XML/1998/namespace" xml:space="preserve">
                    <g id="Layer_x0020_1">
                      <path class="fil0" d="M 2565 2872 l 758 0 l 0 -2872 l 932 0 l 0 2872 l 0 5131 l -932 0 l -758 0 c -1411 0 -2565 -1154 -2565 -2565 l 0 0 c 0 -1411 1154 -2565 2565 -2565 Z m -54 987 l 812 0 l 0 3157 l -812 0 c -868 0 -1579 -710 -1579 -1579 l 0 0 c 0 -868 710 -1579 1579 -1579 Z" />
                      <path class="fil1" d="M 6391 2872 l -758 0 l 0 -2872 l -932 0 l 0 2872 l 0 5131 l 932 0 l 758 0 c 1411 0 2565 -1154 2565 -2565 l 0 0 c 0 -1411 -1154 -2565 -2565 -2565 Z m 54 987 l -812 0 l 0 3157 l 812 0 c 868 0 1579 -710 1579 -1579 l 0 0 c 0 -868 -710 -1579 -1579 -1579 Z" />
                    </g>
                  </svg> -->
            </div>
          </div>
        </div>
      </ng-template>

      <!-- TABLE AND CHART (LEFT TABLE AND RIGHT CHART) -->
      <ng-template #tableChart>
        <div nz-row class="tableChart">
          <div nz-col nzSpan="16" nzOffset="4">
            <h3 nz-typography class="p-title" *ngIf="slide.showTitle">
              {{ slide.title }}
            </h3>

            <div
              *ngIf="slide.storedProcedure == 'textslide1' || slide.storedProcedure == 'textslide2' || slide.storedProcedure == 'textslide3' || slide.storedProcedure == 'textslide4' || slide.storedProcedure == 'textslide5' || slide.storedProcedure == 'textslide6' || slide.storedProcedure == 'textslide7' || slide.storedProcedure == 'textslide8'; then withImg; else onlyText">
            </div>

            <ng-template #withImg>
              <div nz-row class="slideImage" [ngClass]="{ 'two-img': slide.id == 2 }">
                <div nz-col nzSpan="24" class="img">
                  <div>
                    <img src="assets/img/{{ slide.storedProcedure }}.jpg" class="img-title" />
                  </div>
                  <div *ngIf="slide.id == '2'">
                    <img src="assets/img/{{ slide.id }}.jpg" class="img-title" />
                  </div>
                </div>
                <div nz-col nzSpan="24" nz-typography class="slideText" [innerHtml]="convert(slide.content)"></div>
              </div>
            </ng-template>

            <ng-template #onlyText>
              <div nz-typography class="slideText" [innerHtml]="convert(slide.content)"></div>
            </ng-template>

            <div nz-row>
              <div nz-col nzSpan="12">
                <nz-table #slideTable [nzData]="slide.accounts" nzSize="small" [nzFrontPagination]="false"
                  nzTableLayout="fixed" [ngClass]="'totals_table'">
                  <thead>
                    <!--Tabelul mic cu grafic langa el-->
                    <tr>
                      <th style="width: 70%">{{ slide.title | translate }}</th>
                      <th style="width: 30%; text-align: right" [ngClass]="{ negative: slide.value < 0 }">
                        {{ slide.value | number : "1.0-0" : "ro" }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let result of slideTable.data; let i = index">
                      <tr>
                        <td>{{ result.account_description | translate }}</td>
                        <td style="text-align: right" [ngClass]="{ negative: result.value < 0 }">
                          {{ result.value | number : "1.0-0" : "ro" }}
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </nz-table>
              </div>
              <div nz-col nzSpan="12">
                <div style="display: block">
                  <google-chart *ngIf="slide.chartType" [type]="typeChart[slide.chartType]"
                    [data]="chartsData[slide.id]" [columnNames]="columnNames[slide.id]" [options]="optionsChart"
                    [width]="widthChart" [height]="400"></google-chart>
                </div>
              </div>
            </div>
          </div>

          <div nz-col nzSpan="24" [ngClass]="'p-content list-content slide green'" *ngIf="slide.notes !== null">
            <div nz-col nzSpan="16" ngOffset="8">
              <div class="logo-icon">
                <svg xmlns="http://www.w3.org/2000/svg"
                  style="clip-rule: evenodd; fill-rule: evenodd; shape-rendering: geometricPrecision; text-rendering: geometricPrecision; image-rendering: optimizeQuality"
                  viewBox="0 0 8956 8003" version="1.1" xmlns:xml="http://www.w3.org/XML/1998/namespace"
                  xml:space="preserve">
                  <g id="Layer_x0020_1">
                    <path class="fil0"
                      d="M 2565 2872 l 758 0 l 0 -2872 l 932 0 l 0 2872 l 0 5131 l -932 0 l -758 0 c -1411 0 -2565 -1154 -2565 -2565 l 0 0 c 0 -1411 1154 -2565 2565 -2565 Z m -54 987 l 812 0 l 0 3157 l -812 0 c -868 0 -1579 -710 -1579 -1579 l 0 0 c 0 -868 710 -1579 1579 -1579 Z">
                    </path>
                    <path class="fil1"
                      d="M 6391 2872 l -758 0 l 0 -2872 l -932 0 l 0 2872 l 0 5131 l 932 0 l 758 0 c 1411 0 2565 -1154 2565 -2565 l 0 0 c 0 -1411 -1154 -2565 -2565 -2565 Z m 54 987 l -812 0 l 0 3157 l 812 0 c 868 0 1579 -710 1579 -1579 l 0 0 c 0 -868 -710 -1579 -1579 -1579 Z">
                    </path>
                  </g>
                </svg>
              </div>
              <div class="notes" [innerHtml]="notesConvert(slide.notes, slide.id)"></div>
            </div>
          </div>
        </div>
      </ng-template>

      <ng-template #tableChartCollapse>
        <div nz-row *ngIf="slide.chapter == '5' && slide.order == '1'">
          <div nz-col nzSpan="18" nzOffset="3">
            <div class="master-expand-control" (click)="toggleAllPanels()">
              <span class="expand-text db-collapse">{{'bilant_expand_title' | translate}}</span>
              <i nz-icon [nzType]="allPanelsExpanded ? 'down' : 'right'" nzTheme="outline"></i>
            </div>
          </div>
        </div>

        <div nz-row class="tableChart tableChartCollapse">
          <!-- Master expand/collapse control -->

          <nz-collapse [nzExpandIconPosition]="'right'">
            <nz-collapse-panel [nzHeader]="slide.title" [nzActive]="allPanelsExpanded" [nzDisabled]="false">
              <div nz-col nzSpan="16" nzOffset="4">
                <!-- Rest of your existing content remains the same -->
                <div
                  *ngIf="slide.storedProcedure == 'textslide1' || slide.storedProcedure == 'textslide2' || slide.storedProcedure == 'textslide3' || slide.storedProcedure == 'textslide4' || slide.storedProcedure == 'textslide5' || slide.storedProcedure == 'textslide6' || slide.storedProcedure == 'textslide7' || slide.storedProcedure == 'textslide8'; then withImg; else onlyText">
                </div>

                <ng-template #withImg>
                  <div nz-row class="slideImage" [ngClass]="{ 'two-img': slide.id == 2 }">
                    <div nz-col nzSpan="24" class="img">
                      <div>
                        <img src="assets/img/{{ slide.storedProcedure }}.jpg" class="img-title" />
                      </div>
                      <div *ngIf="slide.id == '2'">
                        <img src="assets/img/{{ slide.id }}.jpg" class="img-title" />
                      </div>
                    </div>
                    <div nz-col nzSpan="24" nz-typography class="slideText" [innerHtml]="convert(slide.content)"></div>
                  </div>
                </ng-template>

                <ng-template #onlyText>
                  <div nz-typography class="slideText" [innerHtml]="convert(slide.content)"></div>
                </ng-template>

                <div nz-row>
                  <div nz-col nzSpan="12">
                    <nz-table #slideTable [nzData]="slide.accounts" nzSize="small" [nzFrontPagination]="false"
                      nzTableLayout="fixed" [ngClass]="'totals_table'">
                      <thead>
                        <tr>
                          <th style="width: 70%">{{ slide.title | translate }}</th>
                          <th style="width: 30%; text-align: right" [ngClass]="{ negative: slide.value < 0 }">
                            {{ slide.value | number : "1.0-0" : "ro" }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container *ngFor="let result of slideTable.data; let i = index">
                          <tr>
                            <td>{{ result.account_description | translate }}</td>
                            <td style="text-align: right" [ngClass]="{ negative: result.value < 0 }">
                              {{ result.value | number : "1.0-0" : "ro" }}
                            </td>
                          </tr>
                        </ng-container>
                      </tbody>
                    </nz-table>
                  </div>
                  <div nz-col nzSpan="12">
                    <div style="display: block">
                      <google-chart *ngIf="slide.chartType" [type]="typeChart[slide.chartType]"
                        [data]="chartsData[slide.id]" [columnNames]="columnNames[slide.id]" [options]="optionsChart"
                        [width]="widthChart" [height]="heightChart"></google-chart>
                    </div>
                  </div>
                </div>
              </div>

              <div nz-col nzSpan="24" [ngClass]="'p-content list-content slide green'" *ngIf="slide.notes !== null">
                <div nz-col nzSpan="16" ngOffset="8">
                  <div class="logo-icon">
                    <svg xmlns="http://www.w3.org/2000/svg"
                      style="clip-rule: evenodd; fill-rule: evenodd; shape-rendering: geometricPrecision; text-rendering: geometricPrecision; image-rendering: optimizeQuality"
                      viewBox="0 0 8956 8003" version="1.1" xmlns:xml="http://www.w3.org/XML/1998/namespace"
                      xml:space="preserve">
                      <g id="Layer_x0020_1">
                        <path class="fil0"
                          d="M 2565 2872 l 758 0 l 0 -2872 l 932 0 l 0 2872 l 0 5131 l -932 0 l -758 0 c -1411 0 -2565 -1154 -2565 -2565 l 0 0 c 0 -1411 1154 -2565 2565 -2565 Z m -54 987 l 812 0 l 0 3157 l -812 0 c -868 0 -1579 -710 -1579 -1579 l 0 0 c 0 -868 710 -1579 1579 -1579 Z">
                        </path>
                        <path class="fil1"
                          d="M 6391 2872 l -758 0 l 0 -2872 l -932 0 l 0 2872 l 0 5131 l 932 0 l 758 0 c 1411 0 2565 -1154 2565 -2565 l 0 0 c 0 -1411 -1154 -2565 -2565 -2565 Z m 54 987 l -812 0 l 0 3157 l 812 0 c 868 0 1579 -710 1579 -1579 l 0 0 c 0 -868 -710 -1579 -1579 -1579 Z">
                        </path>
                      </g>
                    </svg>
                  </div>
                  <div class="notes" [innerHtml]="notesConvert(slide.notes, slide.id)"></div>
                </div>
              </div>
            </nz-collapse-panel>
          </nz-collapse>
        </div>
      </ng-template>
      <!-- <ng-template #tableChartCollapse> -->
      <!--   <div nz-row class="tableChart tableChartCollapse"> -->
      <!--     <nz-collapse [nzExpandIconPosition]="'right'"> -->
      <!--       <nz-collapse-panel [nzHeader]="slide.title" [nzActive]="false" [nzDisabled]="false"> -->
      <!--         <div nz-col nzSpan="16" nzOffset="4"> -->
      <!---->
      <!--           <div *ngIf="slide.storedProcedure == 'textslide1' || slide.storedProcedure == 'textslide2' || slide.storedProcedure == 'textslide3' || slide.storedProcedure == 'textslide4' || slide.storedProcedure == 'textslide5' || slide.storedProcedure == 'textslide6' || slide.storedProcedure == 'textslide7' || slide.storedProcedure == 'textslide8'; then withImg; else onlyText"></div> -->
      <!---->
      <!--           <ng-template #withImg> -->
      <!--             <div nz-row class="slideImage" [ngClass]="{ 'two-img': slide.id == 2 }"> -->
      <!--               <div nz-col nzSpan="24" class="img"> -->
      <!--                 <div> -->
      <!--                   <img src="assets/img/{{ slide.storedProcedure }}.jpg" class="img-title" /> -->
      <!--                 </div> -->
      <!--                 <div *ngIf="slide.id == '2'"> -->
      <!--                   <img src="assets/img/{{ slide.id }}.jpg" class="img-title" /> -->
      <!--                 </div> -->
      <!--               </div> -->
      <!--               <div nz-col nzSpan="24" nz-typography class="slideText" [innerHtml]="convert(slide.content)"></div> -->
      <!--             </div> -->
      <!--           </ng-template> -->
      <!---->
      <!--           <ng-template #onlyText> -->
      <!--             <div nz-typography class="slideText" [innerHtml]="convert(slide.content)"></div> -->
      <!--           </ng-template> -->
      <!---->
      <!--           <div nz-row> -->
      <!--             <div nz-col nzSpan="12"> -->
      <!--               <nz-table #slideTable [nzData]="slide.accounts" nzSize="small" [nzFrontPagination]="false" nzTableLayout="fixed" [ngClass]="'totals_table'"> -->
      <!--                 <thead> -->
      <!--                   <tr> -->
      <!--                     <th style="width: 70%">{{ slide.title | translate }}</th> -->
      <!--                     <th style="width: 30%; text-align: right" [ngClass]="{ negative: slide.value < 0 }"> -->
      <!--                       {{ slide.value | number : "1.0-0" : "ro" }} -->
      <!--                     </th> -->
      <!--                   </tr> -->
      <!--                 </thead> -->
      <!--                 <tbody> -->
      <!--                   <ng-container *ngFor="let result of slideTable.data; let i = index"> -->
      <!--                     <tr> -->
      <!--                       <td>{{ result.account_description | translate }}</td> -->
      <!--                       <td style="text-align: right" [ngClass]="{ negative: result.value < 0 }"> -->
      <!--                         {{ result.value | number : "1.0-0" : "ro" }} -->
      <!--                       </td> -->
      <!--                     </tr> -->
      <!--                   </ng-container> -->
      <!--                 </tbody> -->
      <!--               </nz-table> -->
      <!--             </div> -->
      <!--             <div nz-col nzSpan="12"> -->
      <!--               <div style="display: block"> -->
      <!--                 <google-chart *ngIf="slide.chartType" [type]="typeChart[slide.chartType]" [data]="chartsData[slide.id]" [columnNames]="columnNames[slide.id]" [options]="optionsChart" [width]="widthChart" [height]="heightChart"></google-chart> -->
      <!--               </div> -->
      <!--             </div> -->
      <!--           </div> -->
      <!--         </div> -->
      <!---->
      <!--         <div nz-col nzSpan="24" [ngClass]="'p-content list-content slide green'" *ngIf="slide.notes !== null"> -->
      <!--           <div nz-col nzSpan="16" ngOffset="8"> -->
      <!--             <div class="logo-icon"> -->
      <!--               <svg xmlns="http://www.w3.org/2000/svg" style="clip-rule: evenodd; fill-rule: evenodd; shape-rendering: geometricPrecision; text-rendering: geometricPrecision; image-rendering: optimizeQuality" viewBox="0 0 8956 8003" version="1.1" xmlns:xml="http://www.w3.org/XML/1998/namespace" xml:space="preserve"> -->
      <!--                 <g id="Layer_x0020_1"> -->
      <!--                   <path class="fil0" d="M 2565 2872 l 758 0 l 0 -2872 l 932 0 l 0 2872 l 0 5131 l -932 0 l -758 0 c -1411 0 -2565 -1154 -2565 -2565 l 0 0 c 0 -1411 1154 -2565 2565 -2565 Z m -54 987 l 812 0 l 0 3157 l -812 0 c -868 0 -1579 -710 -1579 -1579 l 0 0 c 0 -868 710 -1579 1579 -1579 Z"></path> -->
      <!--                   <path class="fil1" d="M 6391 2872 l -758 0 l 0 -2872 l -932 0 l 0 2872 l 0 5131 l 932 0 l 758 0 c 1411 0 2565 -1154 2565 -2565 l 0 0 c 0 -1411 -1154 -2565 -2565 -2565 Z m 54 987 l -812 0 l 0 3157 l 812 0 c 868 0 1579 -710 1579 -1579 l 0 0 c 0 -868 -710 -1579 -1579 -1579 Z"></path> -->
      <!--                 </g> -->
      <!--               </svg> -->
      <!--             </div> -->
      <!--             <div class="notes" [innerHtml]="notesConvert(slide.notes, slide.id)"></div> -->
      <!--           </div> -->
      <!--         </div> -->
      <!--       </nz-collapse-panel> -->
      <!--     </nz-collapse> -->
      <!--   </div> -->
      <!-- </ng-template> -->

      <!-- TEMPLATE SIMPLE WITH TITLE -->
      <ng-template #title>
        <div nz-row>
          <div nz-col nzSpan="16">
            <h3 nz-typography class="p-title" style="margin: 0px; padding: 0px" *ngIf="slide.showTitle">
              {{ slide.title }}
            </h3>

            <!--             <ul class="title-content footer-quotes-cards" style="height: 370px !important" *ngIf="slide.id == '39'"> -->
            <!--   <li> -->
            <!--                 <div class="slideText text"><p><strong>„Dacă visele tale nu te sperie, înseamnă că nu sunt suficient de mari." </strong>— <em>Richard Branson</em></p></div> -->
            <!--     <div class="slideImage img"> -->
            <!--       <img src="/assets/img/39.jpg" class="img-title" /> -->
            <!--     </div> -->
            <!--   </li> -->
            <!--   <li> -->
            <!--                 <div class="slideText text"><p><strong>„Nu aștepta momentul perfect.  Ia momentul și fă-l perfect." </strong>— <em>Zoey Sayward</em></p></div> -->
            <!--     <div class="slideImage img"> -->
            <!--       <img src="/assets/img/40.jpg" class="img-title" /> -->
            <!--     </div> -->
            <!--   </li> -->
            <!-- </ul> -->
            <ul [ngClass]="{'title-content': !isMobile, 'd-list': !isMobile,'footer-quotes-cards': isMobile}"
              class="print-quotes-section" [ngStyle]="{'height': isMobile ? 'auto' : '370px'}"
              style=" list-style-type: none !important; margin-top: 20px; padding-left:0px" *ngIf="slide.id == '39'">
              <li>
                <div nz-typography class="slideText text"
                  [innerHtml]="convert('<p><strong>„Dacă visele tale nu te sperie, înseamnă că nu sunt suficient de mari.” </strong>— <em>Richard Branson</em></p>')">
                </div>
                <div class="slideImage img">
                  <img src="/assets/img/39.jpg" class="img-title" />
                </div>
              </li>
              <li>
                <div nz-typography class="slideText text"
                  [innerHtml]="convert('<p><strong>„Nu aștepta momentul perfect.  Ia momentul și fă-l perfect.” </strong>— <em>Zoey Sayward</em></p>')">
                </div>
                <div class="slideImage img">
                  <img src="/assets/img/40.jpg" class="img-title" />
                </div>
              </li>
            </ul>
            <!-- <ul class="title-content d-list" style="height: 400px !important"     > -->
            <!--   <li> -->
            <!--     <div nz-typography class="slideText text" [innerHtml]="convert(slide.content)"></div> -->
            <!--     <div *ngIf="slide.id == '39' || slide.id == '40'" class="slideImage img" > -->
            <!--       <img src="/assets/img/{{ slide.id }}.jpg" class="img-title" /> -->
            <!--     </div> -->
            <!--   </li> -->
            <!-- </ul> -->
          </div>
        </div>
      </ng-template>

      <!-- CONCLUSIONS -->
      <ng-template #conclusions>
        <div nz-row>
          <div nz-col nzSpan="16" class="conclusions">
            <!-- <svg enable-background="new 0 0 503.333 503.333" viewBox="0 0 503.333 503.333" xmlns="http://www.w3.org/2000/svg"><g><path d="m306.167 460.583v12.75c0 1.12-.06 2.24-.18 3.33-1.66 15-14.38 26.67-29.82 26.67h-46c-15.44 0-28.16-11.67-29.82-26.67-.12-1.09-.18-2.21-.18-3.33v-12.75c3.97 1.77 8.37 2.75 13 2.75h80c4.63 0 9.03-.98 13-2.75z" fill="#50758d"/><g fill="#ffe7c9"><path d="m251.667 65.563c-4.143 0-7.5-3.357-7.5-7.5v-50.563c0-4.143 3.357-7.5 7.5-7.5s7.5 3.357 7.5 7.5v50.563c0 4.143-3.358 7.5-7.5 7.5z"/><path d="m117.041 121.328c-1.92 0-3.839-.732-5.304-2.196l-35.754-35.755c-2.929-2.93-2.929-7.678 0-10.607 2.931-2.929 7.679-2.927 10.607 0l35.754 35.755c2.929 2.93 2.929 7.678 0 10.607-1.465 1.464-3.385 2.196-5.303 2.196z"/><path d="m61.277 255.953h-50.564c-4.143 0-7.5-3.357-7.5-7.5s3.357-7.5 7.5-7.5h50.563c4.143 0 7.5 3.357 7.5 7.5s-3.357 7.5-7.499 7.5z"/><path d="m81.287 426.333c-1.919 0-3.839-.732-5.304-2.196-2.929-2.93-2.929-7.678 0-10.607l35.754-35.754c2.93-2.928 7.678-2.928 10.607 0 2.929 2.93 2.929 7.678 0 10.607l-35.754 35.754c-1.465 1.464-3.384 2.196-5.303 2.196z"/><path d="m422.046 426.333c-1.919 0-3.839-.732-5.304-2.196l-35.754-35.754c-2.929-2.93-2.929-7.678 0-10.607 2.93-2.928 7.678-2.928 10.607 0l35.754 35.754c2.929 2.93 2.929 7.678 0 10.607-1.464 1.464-3.384 2.196-5.303 2.196z"/><path d="m492.62 255.953h-50.563c-4.143 0-7.5-3.357-7.5-7.5s3.357-7.5 7.5-7.5h50.563c4.143 0 7.5 3.357 7.5 7.5s-3.358 7.5-7.5 7.5z"/><path d="m386.292 121.328c-1.919 0-3.839-.732-5.304-2.196-2.929-2.93-2.929-7.678 0-10.607l35.754-35.755c2.93-2.928 7.678-2.928 10.607 0 2.929 2.93 2.929 7.678 0 10.607l-35.754 35.755c-1.464 1.464-3.384 2.196-5.303 2.196z"/></g><path d="m253.167 453.333s-49.03 9.02-53 7.25v12.75c0 1.12.06 2.24.18 3.33 1.66 15 14.38 26.67 29.82 26.67h13c-13.045 0-24.146-8.331-28.278-19.961-.699-1.967.733-4.039 2.82-4.039h75.458c4.56 0 8.9-.95 12.82-2.67.12-1.09.18-2.21.18-3.33v-12.75c-3.97 1.77-53-7.25-53-7.25z" fill="#2b597f"/><path d="m325.167 431.333c0 13.04-7.81 24.27-19 29.25-3.97 1.77-8.37 2.75-13 2.75h-80c-4.63 0-9.03-.98-13-2.75-11.19-4.98-19-16.21-19-29.25 0 0-.47-46.74-.56-47.96v-.04l72.56-10 71.73 10z" fill="#50758d"/><path d="m230.167 463.333h-17c-4.63 0-9.03-.98-13-2.75-11.19-4.98-19-16.21-19-29.25 0 0-.47-46.74-.56-47.96v-.04h17v.04c.09 1.22.56 47.96.56 47.96 0 13.04 7.81 24.27 19 29.25 3.969 1.77 8.369 2.75 13 2.75z" fill="#2b597f"/><path d="m325.167 430.833h-25.5c-4.14 0-7.5-3.36-7.5-7.5s3.36-7.5 7.5-7.5h25.42l.04 7.5z" fill="#2b597f"/><path d="m272.167 423.333c0 4.14-3.36 7.5-7.5 7.5h-83.51l-.17-15h83.68c4.14 0 7.5 3.36 7.5 7.5z" fill="#2b597f"/><path d="m251.797 90.503c-.001 0-.002 0-.003 0l.003-.003c-77.231-1.188-142.179 66.124-140.79 142.793 0 39.11 15.49 74.56 40.59 100.35 14.79 15.21 27.59 29.27 29.01 49.69l144.29.24c.81-21.02 12.76-35.22 27.65-50.77 24.62-25.71 39.78-60.81 39.78-99.51-.001-78.82-62.9-142.72-140.53-142.79z" fill="#fad207"/><path d="m324.896 383.543v.03l-144.29-.24c-1.42-20.42-14.22-34.48-29.01-49.69-25.1-25.79-40.59-61.24-40.59-100.35-1.39-76.67 63.56-143.98 140.79-142.79 2.49 0 4.97.07 7.43.2-72.95 4.23-132.55 69.11-131.22 142.59 0 39.11 15.49 74.56 40.59 100.35 14.79 15.21 27.59 29.27 29.01 49.69z" fill="#faa515"/><path d="m255.198 304.764c-2.993 3.855-7.539 6.188-12.416 6.369-.206.008-.412.012-.617.012-4.655 0-9.105-1.969-12.24-5.437l-47-51.999c-6.11-6.761-5.583-17.194 1.178-23.305 6.76-6.111 17.192-5.584 23.305 1.177l33.8 37.395 53.927-69.451c5.588-7.197 15.954-8.502 23.151-2.913 7.198 5.589 8.502 15.955 2.913 23.152z" fill="#faa515"/></g></svg> -->
            <!-- <div nz-row>
              <div nz-col nzSpan="18" nzOffset="2"> -->
            <h3 nz-typography class="p-title" *ngIf="slide.showTitle">
              {{ slide.title }}
            </h3>
            <div nz-typography class="slideText" [innerHtml]="convert(slide.content)"></div>
            <!-- </div>
            </div> -->
          </div>
        </div>
      </ng-template>

      <!-- KPI -->
      <ng-template #kpi>
        <div nz-row [ngClass]="'kpi-content'">
          <div nz-col nzSpan="16" style="width: 100%">
            <h3 nz-typography [innerHtml]="convert(slide.title)">
              {{ slide.title }}
            </h3>
            <div nz-typography class="slideText" [innerHtml]="convert(slide.content)"></div>
            <nz-table #totalTable [nzData]="kpi" nzSize="small" [nzLoading]="loadingKpi" [nzFrontPagination]="false"
              [ngClass]="'kpi_table'">
              <thead>
                <tr>
                  <th>{{ "table_title_desc" | translate }}</th>
                  <th style="text-align: right">{{ "table_title_val" | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let kpiItem of kpi; let index = index">
                  <tr *ngIf="!kpi[index - 1] || kpiItem.kpiType !== kpi[index - 1].kpiType">
                    <td colspan="2" style="text-align: left">
                      <h5 nz-typography>{{ kpiItem.kpiType }}</h5>
                    </td>
                  </tr>
                  <tr>
                    <td>{{ kpiItem.kpiDescription | translate }}</td>
                    <td class="kpi_value" [ngClass]="kpiItem.kpiResult">
                      {{ kpiItem.value | number : "0.0-2" : "ro" }}
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </nz-table>
          </div>
        </div>
      </ng-template>

      <!-- PROFIT & CASH -->
      <ng-template #profitCash>
        <div nz-row>
          <div nz-col nzSpan="16">
            <div class="top-content">
              <h3 nz-typography [ngClass]="'p-lg p-title'" style="line-height: 1em" [innerHtml]="convert(slide.title)"
                *ngIf="slide.showTitle"></h3>
              <div [ngClass]="'p-content list-green'" [innerHtml]="convert(slide.content)">
                {{ slide.content }}
              </div>
            </div>
          </div>
          <div nz-col nzSpan="24" [ngClass]="'p-content slide green'" *ngIf="slide.notes != null">
            <div nz-col nzSpan="16" ngOffset="8">
              <div class="logo-icon">
                <svg xmlns="http://www.w3.org/2000/svg"
                  style="clip-rule: evenodd; fill-rule: evenodd; shape-rendering: geometricPrecision; text-rendering: geometricPrecision; image-rendering: optimizeQuality"
                  viewBox="0 0 8956 8003" version="1.1" xmlns:xml="http://www.w3.org/XML/1998/namespace"
                  xml:space="preserve">
                  <g id="Layer_x0020_1">
                    <path class="fil0"
                      d="M 2565 2872 l 758 0 l 0 -2872 l 932 0 l 0 2872 l 0 5131 l -932 0 l -758 0 c -1411 0 -2565 -1154 -2565 -2565 l 0 0 c 0 -1411 1154 -2565 2565 -2565 Z m -54 987 l 812 0 l 0 3157 l -812 0 c -868 0 -1579 -710 -1579 -1579 l 0 0 c 0 -868 710 -1579 1579 -1579 Z">
                    </path>
                    <path class="fil1"
                      d="M 6391 2872 l -758 0 l 0 -2872 l -932 0 l 0 2872 l 0 5131 l 932 0 l 758 0 c 1411 0 2565 -1154 2565 -2565 l 0 0 c 0 -1411 -1154 -2565 -2565 -2565 Z m 54 987 l -812 0 l 0 3157 l 812 0 c 868 0 1579 -710 1579 -1579 l 0 0 c 0 -868 -710 -1579 -1579 -1579 Z">
                    </path>
                  </g>
                </svg>
              </div>
              <div class="notes" [innerHtml]="notesConvert(slide.notes, slide.id)"></div>
            </div>
          </div>
          <!-- <svg height="512" [ngClass]="'bg-logo'" style="top: 0" viewBox="0 0 58 58" width="512" xmlns="http://www.w3.org/2000/svg"><g id="Page-1" fill="none" fill-rule="evenodd"><g id="015---Financial-Profit" transform="translate(0 -1)"><path id="Path" d="m58 2.273-.5 6.442c-.0395612.54260518-.392044 1.0122522-.9019958 1.20181656-.5099518.18956434-1.0836199.06419536-1.4680042-.32081656l-1.45-1.451-9.642 9.655c-1.5637124 1.5602187-4.0952876 1.5602187-5.659 0l-4.463-4.465c-.3904999-.3903819-1.0235001-.3903819-1.414 0l-14.671 14.677c-.750273.7511082-1.768363 1.1731466-2.83 1.1731466s-2.079727-.4220384-2.83-1.1731466l-2.463-2.464c-.39038508-.3897159-1.02261492-.3897159-1.413 0l-4.883 4.875c-.78252302.7694891-2.03747698.7694891-2.82 0-.37849763-.3717318-.59171348-.8799861-.59171348-1.4105s.21321585-1.0387682.59171348-1.4105l5.58-5.592c.75023257-.7508021 1.76810816-1.1726462 2.8295-1.1726462 1.0613918 0 2.0792674.4218441 2.8295 1.1726462l3.169 3.171 15.38-15.381c.7502326-.75080205 1.7681082-1.17264616 2.8295-1.17264616s2.0792674.42184411 2.8295 1.17264616l4.461 4.46c.1875683.187777.4420908.2932867.7075.2932867s.5199317-.1055097.7075-.2932867l8.942-8.946-1.45-1.45c-.3834925-.38332842-.5080245-.95518745-.3186513-1.46326711.1893732-.50807965.6578178-.85892241 1.1986513-.89773289l6.45-.503c.3430962-.02230961.6790523.10499135.9212097.34906611.2421574.24407475.366805.58102432.3417903.92393389z" fill="#52bb00"/><rect id="Rectangle" fill="#f0c419" height="4" rx="2" width="16" x="1" y="55"/><rect id="Rectangle" fill="#f0c419" height="4" rx="2" width="16" x="21" y="55"/><rect id="Rectangle" fill="#f3d55b" height="4" rx="2" width="16" x="21" y="51"/><rect id="Rectangle" fill="#f0c419" height="4" rx="2" width="16" x="21" y="47"/><rect id="Rectangle" fill="#f0c419" height="4" rx="2" width="16" x="41" y="55"/><circle id="Oval" cx="29" cy="38" fill="#f3d55b" r="9"/><rect id="Rectangle" fill="#f3d55b" height="4" rx="2" width="16" x="41" y="51"/><rect id="Rectangle" fill="#f0c419" height="4" rx="2" width="16" x="41" y="47"/><rect id="Rectangle" fill="#f3d55b" height="4" rx="2" width="16" x="41" y="43"/><rect id="Rectangle" fill="#f0c419" height="4" rx="2" width="16" x="41" y="39"/><circle id="Oval" cx="49" cy="30" fill="#f3d55b" r="9"/><circle id="Oval" cx="9" cy="46" fill="#f3d55b" r="9"/><g fill="#b19046"><path id="Path" d="m29 37c-.4851707-.000473-.9000069-.3491365-.9839455-.8269912-.0839386-.4778548.1872399-.9470217.6432053-1.1128119.4559653-.1657902.9651545.0196329 1.2077402.4398031.1727115.3209394.5063525.5225002.8707953.5260692.3644429.003569.7019673-.1914191.880931-.5089145s.1710225-.7072132-.0207263-1.0171547c-.3625283-.608365-.9285888-1.0688648-1.598-1.3v-.2c0-.5522847-.4477153-1-1-1s-1 .4477153-1 1v.184c-1.3765475.4848523-2.2026937 1.8918441-1.9553873 3.330178s1.49595 2.4885874 2.9553873 2.485822c.4851707.000473.9000069.3491365.9839455.8269912.0839386.4778548-.1872399.9470217-.6432053 1.1128119-.4559653.1657902-.9651545-.0196329-1.2077402-.4398031-.2843876-.4596821-.882589-.61017-1.3506397-.3397768s-.6365131.8637835-.3803603 1.3397768c.3630242.6087308.9298468 1.0692742 1.6 1.3v.2c0 .5522847.4477153 1 1 1s1-.4477153 1-1v-.184c1.3769108-.4849733 2.2030823-1.8925391 1.9552305-3.3311676-.2478517-1.4386286-1.4974125-2.4885802-2.9572305-2.4848324z"/><path id="Path" d="m52 32c0-1.6568542-1.3431458-3-3-3-.4851707-.000473-.9000069-.3491365-.9839455-.8269912-.0839386-.4778548.1872399-.9470217.6432053-1.1128119.4559653-.1657902.9651545.0196329 1.2077402.4398031.2843876.4596821.882589.61017 1.3506397.3397768s.6365131-.8637835.3803603-1.3397768c-.3620629-.6087671-.9282899-1.0694024-1.598-1.3v-.2c0-.5522847-.4477153-1-1-1s-1 .4477153-1 1v.184c-1.3765475.4848523-2.2026937 1.8918441-1.9553873 3.330178s1.49595 2.4885874 2.9553873 2.485822c.4851707.000473.9000069.3491365.9839455.8269912.0839386.4778548-.1872399.9470217-.6432053 1.1128119-.4559653.1657902-.9651545-.0196329-1.2077402-.4398031-.2843876-.4596821-.882589-.61017-1.3506397-.3397768s-.6365131.8637835-.3803603 1.3397768c.3625581.6091337.9295478 1.0698128 1.6 1.3v.2c0 .5522847.4477153 1 1 1s1-.4477153 1-1v-.184c1.1935621-.4229269 1.99305-1.5497326 1.998-2.816z"/><path id="Path" d="m9 45c-.48517068-.000473-.90000691-.3491365-.9839455-.8269912-.08393858-.4778548.1872399-.9470217.64320526-1.1128119s.96515455.0196329 1.20774024.4398031c.1727115.3209394.5063525.5225002.8707953.5260692.3644429.003569.7019673-.1914191.880931-.5089145s.1710225-.7072132-.0207263-1.0171547c-.3625283-.608365-.9285888-1.0688648-1.598-1.3v-.2c0-.5522847-.44771525-1-1-1s-1 .4477153-1 1v.184c-1.37654748.4848523-2.2026937 1.8918441-1.95538732 3.330178.24730637 1.4383339 1.49595006 2.4885874 2.95538732 2.485822.48517068.000473.90000691.3491365.9839455.8269912.0839386.4778548-.1872399.9470217-.64320526 1.1128119s-.96515455-.0196329-1.20774024-.4398031c-.17271151-.3209394-.50635246-.5225002-.87079533-.5260692s-.70196724.1914191-.88093096.5089145-.17102255.7072132.02072629 1.0171547c.36302417.6087308.92984682 1.0692742 1.6 1.3v.2c0 .5522847.44771525 1 1 1s1-.4477153 1-1v-.184c1.3769108-.4849733 2.2030823-1.8925391 1.9552305-3.3311676-.2478517-1.4386286-1.4974125-2.4885802-2.9572305-2.4848324z"/></g></g></g></svg> -->
        </div>
      </ng-template>

      <!-- TABLE -->
      <ng-template #table1>
        <div nz-row>
          <div nz-col nzSpan="16" style="width:100%">
            <div class="top-content">
              <ng-container *ngIf="userRole == 'admin' && slide.tableName != 'usefulInfoPlati' && slide.tableName != 'usefulInfoIncasari'">
                <h3 nz-typography [ngClass]="'p-lg p-title'" style="line-height: 1em" *ngIf="slide.showTitle">
                  {{ slide.title }}
                </h3>
                <ng-container *ngIf="slide.content != null">
                  <div [ngClass]="'p-content list-green'" [innerHtml]="convertWithToday(slide.content)">
                    {{ slide.content }}
                  </div>
                </ng-container>
              </ng-container>
              <ng-container
                *ngIf="userRole != 'admin' && slide.tableName != 'usefulInfoPlati' && slide.tableName != 'usefulInfoIncasari'">
                <h3 nz-typography [ngClass]="'p-lg p-title'" style="line-height: 1em" *ngIf="slide.showTitle">
                  {{ slide.title }}
                </h3>
                <ng-container *ngIf="slide.content != null">
                  <div [ngClass]="'p-content list-green'" [innerHtml]="convertWithToday(slide.content)">
                    {{ slide.content }}
                  </div>
                </ng-container>
              </ng-container>


              <!--Tabelul mic cu adaos comercial-->
              <ng-container *ngIf="slide.tableName == 'usefulInfoSolduri'">

                <div *ngFor="let cData of conclusion">
                  <ng-contaniner [ngTemplateOutlet]="tableConclusions" [ngTemplateOutletContext]="{
                        slide: slide,
                        data: cData.usefulInfoSolduri
                      }"></ng-contaniner>
                </div>
              </ng-container>
              <ng-container *ngIf="slide.tableName == 'usefulInfoTVA'">

                <div *ngFor="let cData of conclusion">
                  <ng-contaniner [ngTemplateOutlet]="tableConclusions" [ngTemplateOutletContext]="{
                        slide: slide,
                        data: cData.usefulInfoTVA
                      }"></ng-contaniner>
                </div>
              </ng-container>
              <ng-container *ngIf="userRole == 'admin' && slide.tableName != 'usefulInfoPlati' && slide.tableName != 'usefulInfoIncasari'">
                <ng-container *ngIf="slide.tableName == 'usefulInfoPlati'">
                  <div *ngFor="let cData of conclusion">
                    <ng-container *ngIf="cData.usefulInfoPlati && cData.usefulInfoPlati[0][1] == 1">
                      <ng-contaniner [ngTemplateOutlet]="tableConclusions" [ngTemplateOutletContext]="{
                            slide: slide,
                            data: cData.usefulInfoPlati
                          }"></ng-contaniner>
                    </ng-container>
                  </div>
                </ng-container>
                <ng-container *ngIf="slide.tableName == 'usefulInfoIncasari'">

                  <div *ngFor="let cData of conclusion">
                    <ng-container *ngIf="cData.usefulInfoIncasari && cData.usefulInfoIncasari[0][1] == 1">
                      <ng-contaniner [ngTemplateOutlet]="tableConclusions" [ngTemplateOutletContext]="{
                          slide: slide,
                          data: cData.usefulInfoIncasari
                        }"></ng-contaniner>
                    </ng-container>
                  </div>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="slide.tableName == 'usefulInfoBaniBlocati'">

                <div *ngFor="let cData of conclusion">
                  <ng-contaniner [ngTemplateOutlet]="tableConclusions" [ngTemplateOutletContext]="{
                        slide: slide,
                        data: cData.usefulInfoBaniBlocati
                      }"></ng-contaniner>
                </div>
              </ng-container>
              <ng-container *ngIf="slide.tableName == 'usefulInfoClientiFurnizori'">

                <div *ngFor="let cData of conclusion">
                  <ng-contaniner [ngTemplateOutlet]="tableConclusions" [ngTemplateOutletContext]="{
                        slide: slide,
                        data: cData.usefulInfoClientiFurnizori
                      }"></ng-contaniner>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-template>
      <!-- TABLE -->
      <ng-template #table>
        <div nz-row>
          <div nz-col nzSpan="16">
            <div class="top-content">
              <!-- DE UNDE VINE PROFITUL? waterfall report - above title -->
              <div *ngIf="slide.tableName == 'bp_totals2'">
                <div *ngFor="let totalData of total">
                  <div *ngIf="totalData.t2 != null" class="profit-waterfall">
                    <h3 class="profit-waterfall-title">DE UNDE VINE PROFITUL?</h3>

                    <div class="profit-waterfall-rows">
                      <!-- Din activitatile principale, operationale = EBITDA -->
                      <div class="profit-waterfall-row" [ngClass]="totalData.t2.totals[4].value >= 0 ? 'row-positive' : 'row-negative'">
                        <div class="profit-waterfall-label">Din activitatile principale, operationale</div>
                        <div class="profit-waterfall-value">
                          {{ totalData.t2.totals[4].value | number:'1.0-0':'ro' }}
                        </div>
                      </div>

                      <!-- Amortizarea investitiilor = -Amortizari -->
                      <div class="profit-waterfall-row" [ngClass]="-totalData.t2.totals[6].value >= 0 ? 'row-positive' : 'row-negative'">
                        <div class="profit-waterfall-label">Amortizarea investitiilor</div>
                        <div class="profit-waterfall-value">
                          {{ -totalData.t2.totals[6].value | number:'1.0-0':'ro' }}
                        </div>
                      </div>

                      <!-- Dobanzi si comisioane bancare = Profit financiar -->
                      <div class="profit-waterfall-row" [ngClass]="totalData.t2.totals[15].value >= 0 ? 'row-positive' : 'row-negative'">
                        <div class="profit-waterfall-label">Dobanzi si comisioane bancare</div>
                        <div class="profit-waterfall-value">
                          {{ totalData.t2.totals[15].value | number:'1.0-0':'ro' }}
                        </div>
                      </div>

                      <!-- Despagubiri, amenzi, penalitati, vanzari active = Profit din alte activitati -->
                      <div class="profit-waterfall-row" [ngClass]="totalData.t2.totals[11].value >= 0 ? 'row-positive' : 'row-negative'">
                        <div class="profit-waterfall-label">Despagubiri, amenzi, penalitati, vanzari active</div>
                        <div class="profit-waterfall-value">
                          {{ totalData.t2.totals[11].value | number:'1.0-0':'ro' }}
                        </div>
                      </div>

                      <!-- Impozit pe profit/venit = -Impozit -->
                      <div class="profit-waterfall-row" [ngClass]="-totalData.t2.totals[17].value >= 0 ? 'row-positive' : 'row-negative'">
                        <div class="profit-waterfall-label">Impozit pe profit/venit</div>
                        <div class="profit-waterfall-value">
                          {{ -totalData.t2.totals[17].value | number:'1.0-0':'ro' }}
                        </div>
                      </div>

                      <!-- Arrow -->
                      <div class="profit-waterfall-arrow">
                        <svg width="100" height="50" viewBox="0 0 100 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <defs>
                            <linearGradient id="arrowGrad" x1="50" y1="0" x2="50" y2="50" gradientUnits="userSpaceOnUse">
                              <stop offset="0%" stop-color="#a855f7"/>
                              <stop offset="100%" stop-color="#7c3aed"/>
                            </linearGradient>
                            <filter id="arrowShadow" x="-4" y="-2" width="108" height="58">
                              <feDropShadow dx="0" dy="2" stdDeviation="2" flood-color="#5b21b6" flood-opacity="0.4"/>
                            </filter>
                          </defs>
                          <g filter="url(#arrowShadow)">
                            <rect x="30" y="2" width="40" height="24" rx="4" fill="url(#arrowGrad)"/>
                            <path d="M10 24 L50 46 L90 24 Z" fill="url(#arrowGrad)"/>
                          </g>
                        </svg>
                      </div>

                      <!-- Profit Net result -->
                      <div class="profit-waterfall-result" [ngClass]="totalData.t2.totals[18].value >= 0 ? 'result-positive' : 'result-negative'">
                        <div class="profit-waterfall-result-label">Profit Net</div>
                        <div class="profit-waterfall-result-value">
                          {{ totalData.t2.totals[18].value | number:'1.0-0':'ro' }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <h3 nz-typography [ngClass]="'p-lg p-title'" style="line-height: 1em" *ngIf="slide.showTitle">
                {{ slide.title }}
              </h3>
              <ng-container *ngIf="slide.content != null">
                <div [ngClass]="'p-content list-green'" [innerHtml]="convert(slide.content)">
                  {{ slide.content }}
                </div>
              </ng-container>

              <!--Tabelul mic cu adaos comercial-->
              <ng-container *ngIf="slide.tableName == 'usefulInfo1'">

                <div *ngFor="let cData of conclusion">
                  <ng-contaniner [ngTemplateOutlet]="tableConclusions" [ngTemplateOutletContext]="{
                        slide: slide,
                        data: cData.usefulInfo1
                      }"></ng-contaniner>
                </div>
              </ng-container>
              <ng-container *ngIf="slide.tableName == 'usefulInfo2'">

                <div *ngFor="let cData of conclusion">
                  <ng-contaniner [ngTemplateOutlet]="tableConclusions" [ngTemplateOutletContext]="{
                        slide: slide,
                        data: cData.usefulInfo2
                      }"></ng-contaniner>
                </div>
              </ng-container>

              <ng-container *ngIf="slide.tableName == 'MarjaBrutaTabel'">

                <div *ngFor="let cData of conclusion">
                  <ng-contaniner [ngTemplateOutlet]="tableConclusions" [ngTemplateOutletContext]="{
                      slide: slide,
                      data: cData.MarjaBrutaTabel
                    }"></ng-contaniner>
                </div>
              </ng-container>

              <div *ngIf="slide.tableName == 'concluzii1' || slide.tableName == 'concluzii2'">
                <div *ngFor="let cData of conclusion">
                  <ng-contaniner *ngIf="slide.tableName == 'concluzii1'" [ngTemplateOutlet]="tableConclusions"
                    [ngTemplateOutletContext]="{
                      slide: slide,
                      data: cData.concluzii1
                    }"></ng-contaniner>
                  <ng-contaniner *ngIf="slide.tableName == 'concluzii2'" [ngTemplateOutlet]="tableConclusions"
                    [ngTemplateOutletContext]="{
                      slide: slide,
                      data: cData.concluzii2
                    }"></ng-contaniner>
                </div>
              </div>

              <div *ngIf="slide.tableName == 'bp_totals1' || slide.tableName == 'bp_totals2'">
                <div *ngFor="let totalData of total">
                  <ng-contaniner *ngIf="totalData.t1 != null && slide.tableName == 'bp_totals1'"
                    [ngTemplateOutlet]="tableTotals" [ngTemplateOutletContext]="{
                      slide: slide,
                      data: totalData.t1
                    }"></ng-contaniner>
                  <ng-contaniner *ngIf="totalData.t2 != null && slide.tableName == 'bp_totals2'"
                    [ngTemplateOutlet]="tableTotals" [ngTemplateOutletContext]="{
                      slide: slide,
                      data: totalData.t2
                    }"></ng-contaniner>
                </div>
              </div>

              <div *ngIf="slide.tableName == 'kpi'">
                <ng-contaniner [ngTemplateOutlet]="tableKpi"
                  [ngTemplateOutletContext]="{ slide: slide }"></ng-contaniner>
                <!-- <div *ngFor="let kData of kpi">
                </div> -->
              </div>

              <!-- <ng-contaniner [ngTemplateOutlet]="slide.tableName == 'kpi' ? tableKpi : ''" [ngTemplateOutletContext]="{slide:slide}"></ng-contaniner> -->
            </div>
          </div>

          <ng-container *ngIf="slide.tableName == 'MarjaBrutaTabel'">
            <div nz-col nzSpan="24" [ngClass]="'p-content slide green'" *ngIf="slide.notes != null">
              <div nz-col nzSpan="16" ngOffset="8">
                <div class="logo-icon">
                  <svg xmlns="http://www.w3.org/2000/svg"
                    style="clip-rule: evenodd; fill-rule: evenodd; shape-rendering: geometricPrecision; text-rendering: geometricPrecision; image-rendering: optimizeQuality"
                    viewBox="0 0 8956 8003" version="1.1" xmlns:xml="http://www.w3.org/XML/1998/namespace"
                    xml:space="preserve">
                    <g id="Layer_x0020_1">
                      <path class="fil0"
                        d="M 2565 2872 l 758 0 l 0 -2872 l 932 0 l 0 2872 l 0 5131 l -932 0 l -758 0 c -1411 0 -2565 -1154 -2565 -2565 l 0 0 c 0 -1411 1154 -2565 2565 -2565 Z m -54 987 l 812 0 l 0 3157 l -812 0 c -868 0 -1579 -710 -1579 -1579 l 0 0 c 0 -868 710 -1579 1579 -1579 Z">
                      </path>
                      <path class="fil1"
                        d="M 6391 2872 l -758 0 l 0 -2872 l -932 0 l 0 2872 l 0 5131 l 932 0 l 758 0 c 1411 0 2565 -1154 2565 -2565 l 0 0 c 0 -1411 -1154 -2565 -2565 -2565 Z m 54 987 l -812 0 l 0 3157 l 812 0 c 868 0 1579 -710 1579 -1579 l 0 0 c 0 -868 -710 -1579 -1579 -1579 Z">
                      </path>
                    </g>
                  </svg>
                </div>
                <div class="notes" [innerHtml]="notesConvert(slide.notes, slide.id)"></div>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-template>

      <!-- PIE -->
      <ng-template #pie>
        <div nz-row>
          <div nz-col nzSpan="16">
            <h3 nz-typography [ngClass]="'p-lg p-title'" *ngIf="slide.showTitle" style="line-height: 1em">
              {{ slide.title }}
            </h3>
            <div nz-row>
              <div nz-col nzSpan="12">
                <div [ngClass]="'p-content list-green'" [innerHtml]="convert(slide.content)"></div>
              </div>
              <div nz-col nzSpan="12">
                <google-chart [type]="typeChart[slide.chartType]" [data]="chartsDataConclusion[slide.id]"
                  [columnNames]="columnNames2[slide.id]" [options]="optionsChart" [width]="600"
                  [height]="600"></google-chart>
              </div>
            </div>
          </div>
          <div nz-col nzSpan="24" [ngClass]="'p-content slide green'" *ngIf="slide.notes != null">
            <div nz-col nzSpan="16" ngOffset="8">
              <div class="logo-icon">
                <svg xmlns="http://www.w3.org/2000/svg"
                  style="clip-rule: evenodd; fill-rule: evenodd; shape-rendering: geometricPrecision; text-rendering: geometricPrecision; image-rendering: optimizeQuality"
                  viewBox="0 0 8956 8003" version="1.1" xmlns:xml="http://www.w3.org/XML/1998/namespace"
                  xml:space="preserve">
                  <g id="Layer_x0020_1">
                    <path class="fil0"
                      d="M 2565 2872 l 758 0 l 0 -2872 l 932 0 l 0 2872 l 0 5131 l -932 0 l -758 0 c -1411 0 -2565 -1154 -2565 -2565 l 0 0 c 0 -1411 1154 -2565 2565 -2565 Z m -54 987 l 812 0 l 0 3157 l -812 0 c -868 0 -1579 -710 -1579 -1579 l 0 0 c 0 -868 710 -1579 1579 -1579 Z">
                    </path>
                    <path class="fil1"
                      d="M 6391 2872 l -758 0 l 0 -2872 l -932 0 l 0 2872 l 0 5131 l 932 0 l 758 0 c 1411 0 2565 -1154 2565 -2565 l 0 0 c 0 -1411 -1154 -2565 -2565 -2565 Z m 54 987 l -812 0 l 0 3157 l 812 0 c 868 0 1579 -710 1579 -1579 l 0 0 c 0 -868 -710 -1579 -1579 -1579 Z">
                    </path>
                  </g>
                </svg>
              </div>
              <div class="notes" [innerHtml]="notesConvert(slide.notes, slide.id)"></div>
            </div>
          </div>
        </div>
      </ng-template>

      <!-- BAR -->
      <ng-template #bar>
        <div nz-row class="bars" *ngIf="slide.content != null">
          <div nz-col nzSpan="16">
            <h3 nz-typography [ngClass]="'p-lg p-title'" *ngIf="slide.showTitle" style="line-height: 1em">
              {{ slide.title }}
            </h3>
            <div nz-row>
              <div nz-col nzSpan="12">
                <div [ngClass]="'p-content'" [innerHtml]="convert(slide.content)"></div>
              </div>
              <div nz-col nzSpan="12">
                <ng-container *ngIf="slide.chartType != null">
                  <!-- <ng-container *ngIf="slide.id== '21'"> -->
                  <!--   <div style="text-align: center; font-size: 16px; font-weight: bold; "> -->
                  <!--     <span style="font-size: 16pt"><b>Venituri:&nbsp;{{ venituri21  | number:'1.0-2' }}</b></span><br/> -->
                  <!--     <img src="/assets/img/1balanta.jpg" style="width: 600px"/> -->
                  <!--     <br/> -->
                  <!--     <span [style.font-size.pt]="16" [style.color]="profit21 < 0 ? 'red' : 'inherit'"> -->
                  <!--       <b>Profit: {{ profit21 | number:'1.0-2' }}</b> -->
                  <!--     </span> -->
                  <!--   </div> -->
                  <!-- </ng-container> -->
                  <!-- <ng-container *ngIf="slide.id!= '21'"> -->
                  <!--   <google-chart class="googleChart" [type]="typeChart[slide.chartType]" [data]="chartsData[slide.id]" [columnNames]="columnNames[slide.id]" [options]="optionsChart" [width]="600" [height]="600"></google-chart> -->
                  <!-- </ng-container> -->
                </ng-container>
              </div>
            </div>
          </div>
          <div nz-col nzSpan="24" [ngClass]="'p-content slide notes'" *ngIf="slide.notes != null">
            <div nz-col nzSpan="16" ngOffset="8">
              <div class="logo-icon">
                <svg xmlns="http://www.w3.org/2000/svg"
                  style="clip-rule: evenodd; fill-rule: evenodd; shape-rendering: geometricPrecision; text-rendering: geometricPrecision; image-rendering: optimizeQuality"
                  viewBox="0 0 8956 8003" version="1.1" xmlns:xml="http://www.w3.org/XML/1998/namespace"
                  xml:space="preserve">
                  <g id="Layer_x0020_1">
                    <path class="fil0"
                      d="M 2565 2872 l 758 0 l 0 -2872 l 932 0 l 0 2872 l 0 5131 l -932 0 l -758 0 c -1411 0 -2565 -1154 -2565 -2565 l 0 0 c 0 -1411 1154 -2565 2565 -2565 Z m -54 987 l 812 0 l 0 3157 l -812 0 c -868 0 -1579 -710 -1579 -1579 l 0 0 c 0 -868 710 -1579 1579 -1579 Z">
                    </path>
                    <path class="fil1"
                      d="M 6391 2872 l -758 0 l 0 -2872 l -932 0 l 0 2872 l 0 5131 l 932 0 l 758 0 c 1411 0 2565 -1154 2565 -2565 l 0 0 c 0 -1411 -1154 -2565 -2565 -2565 Z m 54 987 l -812 0 l 0 3157 l 812 0 c 868 0 1579 -710 1579 -1579 l 0 0 c 0 -868 -710 -1579 -1579 -1579 Z">
                    </path>
                  </g>
                </svg>
              </div>
              <div class="notes" [innerHtml]="notesConvert(slide.notes, slide.id)"></div>
            </div>
          </div>
        </div>
      </ng-template>

      <!-- IMAGE BAR -->
      <ng-template #imageBar>
        <div nz-row class="bars images-bars" *ngIf="slide.content != null">
          <div nz-col nzSpan="16">
            <h3 nz-typography [ngClass]="'p-lg p-title'" *ngIf="slide.showTitle" style="line-height: 1em">
              {{ "image_bar_title" | translate }}
            </h3>
            <div nz-row>
              <div nz-col nzSpan="12" class="image-bar">
                <h4 style="text-align: center; margin: 0; padding: 0" *ngIf="slide.id == '21'"
                  [innerHTML]="'image_bar_subtitle1' | translate"></h4>
                <p>
                  <br />
                </p>
                <img src="/assets/img/tabel_all.jpg" *ngIf="slide.id == '21'" />
              </div>
              <div nz-col nzSpan="12">
                <h4 style="text-align: center" *ngIf="slide.id == '21'">
                  <b>{{ "image_bar_subtitle2" | translate }}</b>
                </h4>
                <p style="text-align: center; line-height: 1; font-size: 14px; bottom: 8px" *ngIf="slide.id == '21'"
                  [innerHTML]="'image_bar_subtitlec' | translate"></p>
                <ng-container *ngIf="slide.chartType != null">
                  <google-chart class="googleChart" [type]="typeChart[slide.chartType]" [data]="chartsData[slide.id]"
                    [columnNames]="columnNames[slide.id]" [options]="optionsChart" [width]="600" [height]="575"
                    style="bottom: 5px; position: relative"></google-chart>
                </ng-container>
              </div>
            </div>
            <div [ngClass]="'p-content'" [innerHtml]="convert('image_bar_content' | translate)"></div>
          </div>

          <div nz-col nzSpan="24" [ngClass]="'p-content slide notes'" *ngIf="slide.notes != null">
            <div nz-col nzSpan="16" ngOffset="8">
              <div class="logo-icon">
                <svg xmlns="http://www.w3.org/2000/svg"
                  style="clip-rule: evenodd; fill-rule: evenodd; shape-rendering: geometricPrecision; text-rendering: geometricPrecision; image-rendering: optimizeQuality"
                  viewBox="0 0 8956 8003" version="1.1" xmlns:xml="http://www.w3.org/XML/1998/namespace"
                  xml:space="preserve">
                  <g id="Layer_x0020_1">
                    <path class="fil0"
                      d="M 2565 2872 l 758 0 l 0 -2872 l 932 0 l 0 2872 l 0 5131 l -932 0 l -758 0 c -1411 0 -2565 -1154 -2565 -2565 l 0 0 c 0 -1411 1154 -2565 2565 -2565 Z m -54 987 l 812 0 l 0 3157 l -812 0 c -868 0 -1579 -710 -1579 -1579 l 0 0 c 0 -868 710 -1579 1579 -1579 Z">
                    </path>
                    <path class="fil1"
                      d="M 6391 2872 l -758 0 l 0 -2872 l -932 0 l 0 2872 l 0 5131 l 932 0 l 758 0 c 1411 0 2565 -1154 2565 -2565 l 0 0 c 0 -1411 -1154 -2565 -2565 -2565 Z m 54 987 l -812 0 l 0 3157 l 812 0 c 868 0 1579 -710 1579 -1579 l 0 0 c 0 -868 -710 -1579 -1579 -1579 Z">
                    </path>
                  </g>
                </svg>
              </div>
              <div class="notes" [innerHtml]="'image_bar_notes' | translate"></div>
            </div>
          </div>
        </div>
      </ng-template>


      <!-- IMAGE FLOAT -->
      <ng-template #imageFloat>
        <div nz-row class="bars" *ngIf="slide.content != null">
          <div nz-col nzSpan="16">
            <h3 nz-typography [ngClass]="'p-lg p-title'" *ngIf="slide.showTitle" style="line-height: 1em">
              {{ slide.title }}
            </h3>
            <ng-container *ngIf="slide.id != '0'; then imageFloatContent;"></ng-container>
          </div>
        </div>
      </ng-template>



      <!-- OTHER TEMPLATES -->
      <ng-template #otherTemplate>
        <div nz-row class="other">
          <ng-container *ngIf="slide.id == 34 && slide.content == null">
            <div nz-col nzSpan="18" nzOffset="4">
              <h3 nz-typography class="p-title" style="line-height: 1em; text-align: left;"
                [innerHtml]="convert('Nu ai activitate de vânzare de marfuri')">
              </h3>
            </div>
          </ng-container>
          <div nz-col nzSpan="16" nzOffset="4">
            <h3 nz-typography class="p-title" *ngIf="slide.showTitle &&  slide.content != null"
              [innerHtml]="convert(slide.title)" style="line-height: 1em">
              {{ slide.title }}
            </h3>

            <ng-container *ngIf="slide.storedProcedure != 'textslide8'">
              <div *ngIf="slide.id == '28' || slide.id == '29' || slide.id == '35'; then withImg; else onlyText"></div>
            </ng-container>

            <ng-container
              *ngIf="slide.storedProcedure == 'textslide8'; then imageFloatContent"><br /><br /></ng-container>

            <ng-template #withImg>
              <div nz-row class="slideImage">
                <div nz-col nzSpan="24" class="img">
                  <img src="/assets/img/{{ slide.id }}.jpg" class="img-title"
                    *ngIf="slide.id == 28 || slide.id == 29 || slide.id == 35" />
                  <img src="/assets/img/{{ slide.storedProcedure }}.jpg" class="img-title"
                    *ngIf="slide.storedProcedure == 'textslide8'" />
                </div>
                <div nz-col nzSpan="24" nz-typography class="slideText" *ngIf="slide.id == 28"
                  [innerHtml]="convert('slide_28_content' | translate)"></div>
                <div nz-col nzSpan="24" nz-typography class="slideText" *ngIf="slide.id != 28"
                  [innerHtml]="convert(slide.content)"></div>
              </div>
            </ng-template>


            <div nz-row *ngIf="slide.chartType != null">
              <div nz-col nzSpan="12">
                <h4 *ngIf="slide.id == 8"
                  style="text-align: center; margin-bottom: -4rem; z-index: 2; position: relative">
                  <strong>{{ "s4_left_graph_name" | translate }}</strong>
                </h4>

                <google-chart [type]="typeChart[slide.chartType]" [data]="chartsData[slide.id]"
                  [columnNames]="columnNames[slide.id]" [options]="optionsChart" [width]="600"
                  [height]="400"></google-chart>
              </div>
              <div nz-col nzSpan="12">
                <h4 *ngIf="slide.id == 8"
                  style="text-align: center; margin-bottom: -4rem; z-index: 2; position: relative">
                  <strong>{{ "s4_right_graph_name" | translate }}</strong>
                </h4>

                <google-chart [type]="typeChart[slide.chartType]" [data]="chartsData2[slide.id]"
                  [columnNames]="columnNames2[slide.id]" [options]="optionsChart" [width]="600"
                  [height]="400"></google-chart>
              </div>
            </div>

            <ng-template #onlyText>
              <!--Text sub primul tabel end Check2 si urmatorul dupa tabelul mic cu grafic-->
              <div nz-typography class="slideText" [ngClass]="{ bgGrey: slide.id == '35' }"
                [innerHtml]="convertAndTranslate(slide.content)"></div>
            </ng-template>
          </div>

          <div nz-col nzSpan="24" [ngClass]="'p-content list-content slide green'" *ngIf="slide.notes != null">
            <div nz-col nzSpan="16" ngOffset="8">
              <div class="logo-icon">
                <svg xmlns="http://www.w3.org/2000/svg"
                  style="clip-rule: evenodd; fill-rule: evenodd; shape-rendering: geometricPrecision; text-rendering: geometricPrecision; image-rendering: optimizeQuality"
                  viewBox="0 0 8956 8003" version="1.1" xmlns:xml="http://www.w3.org/XML/1998/namespace"
                  xml:space="preserve">
                  <g id="Layer_x0020_1">
                    <path class="fil0"
                      d="M 2565 2872 l 758 0 l 0 -2872 l 932 0 l 0 2872 l 0 5131 l -932 0 l -758 0 c -1411 0 -2565 -1154 -2565 -2565 l 0 0 c 0 -1411 1154 -2565 2565 -2565 Z m -54 987 l 812 0 l 0 3157 l -812 0 c -868 0 -1579 -710 -1579 -1579 l 0 0 c 0 -868 710 -1579 1579 -1579 Z">
                    </path>
                    <path class="fil1"
                      d="M 6391 2872 l -758 0 l 0 -2872 l -932 0 l 0 2872 l 0 5131 l 932 0 l 758 0 c 1411 0 2565 -1154 2565 -2565 l 0 0 c 0 -1411 -1154 -2565 -2565 -2565 Z m 54 987 l -812 0 l 0 3157 l 812 0 c 868 0 1579 -710 1579 -1579 l 0 0 c 0 -868 -710 -1579 -1579 -1579 Z">
                    </path>
                  </g>
                </svg>
              </div>
              <div class="notes" [innerHtml]="notesConvert(slide.notes, slide.id)"></div>
            </div>
          </div>
        </div>
      </ng-template>

      <ng-template #imageFloatContent>
        <div nz-row>
          <div nz-col nzSpan="24">
            <div [ngClass]="'p-content'">

              <!-- Float container pentru slide 21 -->
              <ng-container *ngIf="slide.id == '21'">
                <div class="float-container balance-float"
                  style="float: right; margin-left: 20px; margin-bottom: 20px; text-align: center;">
                  <div class="balance-content">
                    <span class="revenue-text">
                      <b>Venituri:&nbsp;{{ venituri21 | number:'1.0-2' }}</b>
                    </span><br />
                    <img src="/assets/img/1balanta.png" class="balance-img" alt="Balanță" />
                    <br />
                    <span class="profit-text" [style.color]="profit21 < 0 ? 'red' : 'inherit'">
                      <b>Profit: {{ profit21 | number:'1.0-2' }}</b>
                    </span>
                  </div>
                </div>
              </ng-container>

              <!-- Float container pentru textslide8 -->
              <ng-container *ngIf="slide.storedProcedure == 'textslide8'">
                <div class="float-container slide-float"
                  style="float: left; margin-right: 20px; margin-bottom: 20px; text-align: center;">
                  <img src="/assets/img/textslide8a.jpg" class="slide-img" alt="Text Slide 8" />
                </div>
              </ng-container>

              <!-- Content will wrap around the floated element -->
              <div [innerHtml]="convert(slide.content)" style="margin-bottom: 40px"></div>

              <!-- Clear float -->
              <div style="clear: both;"></div>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
  </nz-spin>

  <!-- TABLES CONTENT/TEMPLATES -->
  <ng-template #tableConclusions let-slide="slide" let-data="data">
    <nz-table #conclusionsTable [nzData]="conclusion" nzSize="small" [nzFrontPagination]="false" nzTableLayout="fixed"
      [ngClass]="'conclusions_table'" *ngIf="data != null">
      <thead *ngIf="slide.tableName == 'MarjaBrutaTabel'">
        <tr>
          <th>{{ "conclusion_activity" | translate }}</th>
          <th style="text-align: right">{{ "conclusion_value" | translate }}</th>
        </tr>
      </thead>
      <thead *ngIf="slide.tableName != 'MarjaBrutaTabel' && slide.tableName != 'concluzii1'">
        <tr>
          <th>{{ "table_title_desc" | translate }}</th>
          <th style="text-align: right">{{ "table_title_val" | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let cResult of data">
          <tr [ngClass]="{
              highlight: cResult[0] == 'Profitul din balanta' || cResult[0] == 'Cash-ul din banci si casierie' || cResult[0] == 'Profit net' || cResult[1] == '%' || cResult[1] == 'Adaos comercial' || cResult[0] == 'Total credite la data balantei' || cResult[0] == 'Total plati efectuate' || cResult[0] == 'Total bani blocati pentru care se asteapta decontarea' || cResult[0] == 'Total incasari',
              lowlight: cResult[0] == 'Diferente' || cResult[2] == 'parent',
              tablehead: cResult[0] == 'VENITURI OPERATIONALE'
            }" *ngIf="cResult[0] != 'Display'">
            <!--Tabelul dinaintea grafului cu 2 coloane-->
            <td *ngIf="slide.tableName != 'MarjaBrutaTabel'"
              [ngStyle]="{'padding-left': cResult[2] == 'child' ? '20px' : ''}">
              {{ cResult[0] | translate }}
            </td>
            <td style="text-align: right" [ngClass]="{ negative: cResult[1] < 0 }" *ngIf="isNum(cResult[1])">
              {{ cResult[1] | number : "1.0-0" : "ro" }}
            </td>
            <td style="text-align: left" [ngClass]="{ negative: cResult[1] < 0 }" *ngIf="!isNum(cResult[1])">
              {{ cResult[1] | translate }}
              <!-- <span *ngIf="cResult[1] != '%'">{{ cResult[1] }}</span> -->
            </td>
            <!-- <td style="text-align: left;" [ngClass]="{'negative': cResult[1] < 0}" *ngIf="!isNum(cResult[1])"><span *ngIf="cResult[1] == '%'">{{ cResult[1] }}</span></td> -->
            <td style="text-align: right" [ngClass]="{ negative: cResult[2] < 0 }"
              *ngIf="isNum(cResult[2]) && cResult[2] != null">
              <ng-container *ngIf="slide.id == 19">{{ cResult[2] }}</ng-container>
              <ng-container *ngIf="cResult[1] == '%'">
                {{ cResult[2] | number : "0.2-2" : "ro" }}
              </ng-container>

              <ng-container *ngIf="slide.id != 19 && cResult[1] != '%'">{{ cResult[2] | number : "1.0-0" : "ro"
                }}</ng-container>
            </td>
            <td style="text-align: right" [ngClass]="{ negative: cResult[2] < 0 }"
              *ngIf="!isNum(cResult[2]) && cResult[2] != null && cResult[2] != 'parent' && cResult[2] != 'child'">
              {{ cResult[2] | translate }}
            </td>
            <!-- <td style="text-align: right;" *ngIf="!isNum(cResult[2]) && cResult[2] == null"></td> -->
          </tr>
        </ng-container>
      </tbody>
    </nz-table>
  </ng-template>

  <ng-template #tableTotals let-slide="slide" let-data="data">
    <!-- <h4 nz-typography>{{ data.title }}</h4> -->
    <!-- <div [ngClass]="'p-content list-content list-green'" [innerHtml]="convert('table_total_content' | translate)"> -->
    <!--   {{ slide.content }} -->
    <!-- </div> -->

    <div style="margin-bottom: 12px; text-align: center;">
      <button nz-button nzType="primary" class="print-btn" (click)="toggleAllTotalsExpand(data.totals, data.title)">
        <i nz-icon [nzType]="isTableExpanded(data.title) ? 'minus-square' : 'plus-square'" nzTheme="outline"></i>
        {{ isTableExpanded(data.title) ? 'RESTRÂNGE TOT' : 'EXTINDE TOT' }}
      </button>
    </div>

    <nz-spin [nzSpinning]="loadingTotals">
      <nz-table #totalTable [nzData]="data.totals" nzSize="small" [nzFrontPagination]="false" nzTableLayout="fixed"
        [ngClass]="'totals_table'">
        <thead>
          <tr>
            <th nzWidth="60px"></th>
            <th>{{ "table_title_desc" | translate }}</th>
            <th style="text-align: right">{{ "table_title_val" | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let result of totalTable.data; let i = index">
            <ng-container>
              <tr [ngClass]="{
                  highlight: result.description.includes('EBITDA') || result.description.includes('EBIT') || result.description.includes('Profit din alte activitati') || result.description.includes('Profit financiar') || result.description === 'Profit net' || result.description.includes('pn') || result.description.includes('TOTAL PASIV') || result.description.includes('TOTAL ACTIV'),
                  check: result.description === 'Check 1' || result.description === 'Check 2',
                  upper: result.description.includes('ebit')
                }"
                *ngIf="(userRole == 'admin' && (result.description === 'Check 1' || result.description === 'Check 2' || result.description === 'Profit net din balanta')) || (result.description !== 'Check 1' && result.description !== 'Check 2' && result.description !== 'Profit net din balanta')">
                <td [nzExpand]="expandSet.has(result.id)" (nzExpandChange)="onExpandChange(result.id, $event)"
                  *ngIf="isNum(result.accountTypeId)"></td>
                <td *ngIf="!isNum(result.accountTypeId)"></td>
                <!--EXPAND NAME 1st table-->
                <td>{{ result.description | translate }}</td>
                <td style="text-align: right" *ngIf="result.description != '%'"
                  [ngClass]="{ negative: result.value < 0 }">
                  {{ result.value | number : "1.0-0" : "ro" }}
                </td>
                <td style="text-align: right" *ngIf="result.description == '%'"
                  [ngClass]="{ negative: result.value < 0 }">{{ result.value | number : "1.1-1" : "ro" }}%</td>
              </tr>
            </ng-container>

            <tr [nzExpand]="expandSet.has(result.id)" *ngIf="result.group">
              <nz-table #accountsTable [nzData]="total" [nzLoading]="loadingAccounts" [nzFrontPagination]="false"
                [nzShowPagination]="false">
        <tbody nz-tbody>
          <ng-container *ngFor="let group of result.group">
            <tr>
              <td [nzExpand]="expandSet.has(group.id)" (nzExpandChange)="onExpandChange(group.id, $event)"
                *ngIf="isNum(group.accountTypeId)"></td>
              <td>{{ group.description | translate }}</td>
              <td style="text-align: right" [ngClass]="{ negative: account.value < 0 }">
                {{ group.value | number : "1.0-0" : "ro" }}
              </td>
            </tr>

            <tr [nzExpand]="expandSet.has(group.id)" *ngIf="isNum(group.accountTypeId)">
              <nz-table #accountsGroupTable [nzData]="account" [nzLoading]="loadingAccounts" [nzFrontPagination]="false"
                [nzShowPagination]="false">
        <tbody nz-tbody>
          <ng-container *ngFor="let acc of accountsGroupTable.data">
            <tr *ngIf="group.accountTypeId == acc.accountTypeId && acc.value !== 0">
              <td>{{ acc.accountDescription | translate }}</td>
              <td style="text-align: right" [ngClass]="{ negative: acc.value < 0 }">
                {{ acc.value | number : "1.0-0" : "ro" }}
              </td>
            </tr>
          </ng-container>
        </tbody>
      </nz-table>
      </tr>
      </ng-container>
      </tbody>
      </nz-table>
      </tr>

      <tr [nzExpand]="expandSet.has(result.id)" *ngIf="isNum(result.accountTypeId) && !result.group">
        <nz-table #accountsTable [nzData]="account" [nzLoading]="loadingAccounts" [nzFrontPagination]="false"
          [nzShowPagination]="false">
          <tbody>
            <ng-container *ngFor="let account of accountsTable.data">
              <tr *ngIf="result.accountTypeId == account.accountTypeId && account.value !== 0">
                <td>{{ account.accountDescription | translate }}</td>
                <td>
                  <ng-container *ngIf="userRole == 'admin'">{{ account.accountCode }}</ng-container>
                </td>
                <td style="text-align: right" [ngClass]="{ negative: account.value < 0 }">
                  {{ account.value | number : "1.0-0" : "ro" }}
                </td>
              </tr>
            </ng-container>
          </tbody>
        </nz-table>
      </tr>
      </ng-container>
      </tbody>
      </nz-table>
    </nz-spin>
  </ng-template>

  <ng-template #tableKpi let-slide="slide">
    <!-- <div *ngIf="
      slide.id == '30';
      then withImg else onlyText
    "></div> -->
    <ng-template #withImg>
      <div nz-row class="slideImage">
        <div nz-col nzSpan="24" class="img">
          <img src="/assets/img/{{ slide.id }}.jpg" class="img-title" />
        </div>
        <div nz-col nzSpan="24" nz-typography class="slideText" [innerHtml]="convert(slide.content)"></div>
      </div>
    </ng-template>

    <ng-template #onlyText>
      <div nz-typography class="slideText" [innerHtml]="convert(slide.content)"></div>
    </ng-template>

    <nz-table #kpiTable [nzData]="kpi" nzSize="small" [nzLoading]="loadingKpi" [nzFrontPagination]="false"
      [ngClass]="'kpi_table'">
      <thead>
        <tr>
          <th>{{ "table_title_desc" | translate }}</th>
          <th style="text-align: right">{{ "table_title_val" | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let kpiItem of kpi; let index = index">
          <tr *ngIf="!kpi[index - 1] || kpiItem.kpiType !== kpi[index - 1].kpiType" [ngClass]="{
              highlight: kpiItem.kpiType.includes('Ratii Bilantiere') || kpiItem.kpiType.includes('Rotatia Capitalului') || kpiItem.kpiType.includes('Rate de indatorare') || kpiItem.kpiType.includes('Indicatori')
            }">
            <td colspan="2" style="text-align: left">
              <h5 nz-typography>{{ kpiItem.kpiType | translate }}</h5>
            </td>
          </tr>
          <tr>
            <!-- <td [nzExpand]="expandSet.has(index)" (nzExpandChange)="onExpandChange(index, $event)" *ngIf="kpiItem.kpiColorDescription != null">{{ kpiItem.kpiDescription }}</td> -->
            <td>{{ kpiItem.kpiDescription | translate }}</td>
            <td class="kpi_value" [ngClass]="kpiItem.kpiResult">
              {{ kpiItem.value | number : "0.0-2" : "ro" }}
            </td>
          </tr>
          <!-- <tr [nzExpand]="expandSet.has(index)" *ngIf="kpiItem.kpiColorDescription != null">
            {{ kpiItem.kpiColorDescription }}
          </tr> -->
        </ng-container>
      </tbody>
    </nz-table>

    <nz-collapse [nzExpandIconPosition]="'right'">
      <nz-collapse-panel [nzHeader]="'kpi_expand_title' | translate" [nzActive]="kpiPanelExpanded" [nzDisabled]="false"
        class="db-collapse">
        <ng-container *ngFor="let kpiItem of kpi; let index = index">
          <p *ngIf="kpiItem.kpiBenchmark != null" [innerHtml]="convert(kpiItem.kpiBenchmark | translate)"></p>
          <p *ngIf="kpiItem.kpiColorDescription != null" [innerHtml]="convert(kpiItem.kpiColorDescription | translate)"
            class="kpi-{{ kpiItem.kpiResult }}"></p>
          <div class="kpi-line"></div>
        </ng-container>
      </nz-collapse-panel>
    </nz-collapse>
  </ng-template>
  <!-- TABLES CONTENT/TEMPLATES -->
</div>

<nz-spin [nzSpinning]="loadingSlides">
  <div nz-row class="print-pdf" nzJustify="center">
    <div nz-col nzXs="22" nzSm="16" nzMd="12" nzLg="10" 
         style="text-align: center; display: flex; flex-direction: column; align-items: center; gap: 1rem; margin-bottom: 2rem;">
      
      <!-- Desktop: Print și Email pe același rând -->
      <div class="action-buttons-row">
        <button nz-button nzType="primary" class="print-btn" (click)="printReport()">
          <i nz-icon nzType="printer"></i>
          {{ "print_btn" | translate }}
        </button>
        <button nz-button nzType="primary" class="email-btn" (click)="toggleEmailForm()">
          <i nz-icon nzType="mail"></i>
          Trimite pe email
        </button>
      </div>

      <!-- Formular email - apare când se apasă butonul -->
      <div class="email-form-container" *ngIf="showEmailForm">
        <div class="email-form-header">
          <span>Trimite raportul pe email</span>
          <button nz-button nzType="text" nzSize="small" (click)="toggleEmailForm()">
            <i nz-icon nzType="close"></i>
          </button>
        </div>
        
        <nz-input-group [nzSuffix]="sendButtonTpl" nzSize="large" class="email-input-group">
          <input 
            type="email" 
            nz-input 
            placeholder="exemplu@email.com" 
            [(ngModel)]="recipientEmail"
            [disabled]="sendingEmail"
            (keyup.enter)="isValidEmail(recipientEmail) && !sendingEmail && sendReportByEmail()"
          />
        </nz-input-group>
        
        <ng-template #sendButtonTpl>
          <button 
            nz-button 
            nzType="primary" 
            nzSize="small"
            [nzLoading]="sendingEmail"
            [disabled]="!isValidEmail(recipientEmail) || sendingEmail"
            (click)="sendReportByEmail()"
            class="send-email-btn"
          >
            <i nz-icon nzType="send" *ngIf="!sendingEmail"></i>
            {{ sendingEmail ? 'Se trimite...' : 'Trimite' }}
          </button>
        </ng-template>
        
        <span class="email-error" *ngIf="recipientEmail && !isValidEmail(recipientEmail)">
          <i nz-icon nzType="exclamation-circle"></i>
          Introduceți o adresă de email validă
        </span>
      </div>

      <button class="evolution-button" (click)="openDiagnostic()">
        DIAGNOSTIC FINANCIAR
      </button>
    </div>
  </div>
</nz-spin>
